import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ReportsPage } from "./inner-components";

export const RepPage = (props) => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className='full-flex flexCol width100 p-0 m-0'>
        <Routes>
          <Route path="/" element={<ReportsPage />} />
        </Routes>
      </div>
    </div>
  )
}